/**
 * Environment configuration utility
 * Centralizes all environment variable access and provides type safety
 *
 * IMPORTANT:
 * - ALL modes now use REAL API calls to backend
 * - No more mock data support
 */
import { debug } from '../utils/debug';

export const ENV = {
  // API configuration
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3333',
  PAYMENTS_SERVICE_URL: import.meta.env.VITE_PAYMENT_SERVICE_URL || 'http://localhost:3334',

  // Environment type
  NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development',

  // Computed properties
  get IS_DEVELOPMENT() {
    return this.NODE_ENV === 'development';
  },

  get IS_PRODUCTION() {
    return this.NODE_ENV === 'production';
  },
} as const;

// Type for environment configuration
export type Environment = typeof ENV;

// Helper function to log environment configuration (development only)
export const logEnvironmentConfig = () => {
  debug.log('Mode:', import.meta.env.MODE);
  debug.log('API URL:', ENV.API_URL);
  debug.log('Payments Service URL:', ENV.PAYMENTS_SERVICE_URL);
  debug.log('Environment:', ENV.NODE_ENV);
  debug.log('Is Development:', ENV.IS_DEVELOPMENT);
  debug.log('Is Production:', ENV.IS_PRODUCTION);
  debug.log('API Mode:', 'REAL API ONLY');
};
